import { postRequest } from "./api.request";

const RELIEF_PATH = "/relief/v1";

export const addReliefApi = async (body) =>
  await postRequest(RELIEF_PATH, body);
